import { memo, useCallback } from 'react';
import { Text, Badge, Tooltip } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { getLiteral } from 'utils/getLiteral';
import { BaseReactCell } from '@Sage/ssm-web5';

const TagCell = memo(({ data, value, open, ...props }) => {
    const onClick = useCallback(() => open(data?.automationId), [data?.automationId, open]);

    return (
        <BaseReactCell data={data} {...props}>
            <div className="fm-automation-settings__tag-cell">
                <div className="fm-automation-settings__tag-cell__name">
                    <Text
                        className={classnames('fm-automation-settings__tag-cell__text', {
                            'fm-automation-settings__tag-cell__text--blocked': data?.blocked,
                        })}
                        type="subtitle"
                        medium
                        isTruncated
                        useTooltip
                        onClick={data?.blocked ? undefined : onClick}
                    >
                        {value}
                    </Text>
                </div>
                {data?.blocked && (
                    <Tooltip content={getLiteral('label_automation_stopped_desc_1')}>
                        <Badge type="semanticNegative">
                            {getLiteral('label_automation_stopped')}
                        </Badge>
                    </Tooltip>
                )}
            </div>
        </BaseReactCell>
    );
});

export default TagCell;
